export default () => ({
  email: null,
  name: null,
  goalId: -1,
  goalName: null,
  score: null
})
